import React from 'react';
import logo from '../assets/logo.png';
import { branch, BOOKING_URL, hoursSummary } from '../data/siteData';

const quickLinks = [
  { label: 'Ana Sayfa',        href: '#home',     external: false },
  { label: 'Hakkımızda',       href: '#about',    external: false },
  { label: 'Hizmetlerimiz',    href: '#services', external: false },
  { label: 'Randevu Al',       href: BOOKING_URL, external: true  },
  { label: 'Konum & İletişim', href: '#contact',  external: false },
];

const socials = [
  { label: 'Instagram', href: '#',                                  icon: '📸' },
  { label: 'Facebook',  href: '#',                                  icon: '👍' },
  { label: 'TikTok',    href: '#',                                  icon: '🎵' },
  { label: 'WhatsApp',  href: `https://wa.me/${branch.phonePlain}`, icon: '💬' },
];

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">

        {/* Brand */}
        <div className="footer-section">
          <div className="footer-logo">
            <div className="footer-logo-circle">
              <img src={logo} alt="Bloome Beauty Batıkent" />
            </div>
            <div className="footer-brand">
              <div className="name">Bloome Beauty</div>
              <div className="sub">Batıkent</div>
            </div>
          </div>
          <p className="footer-tagline">
            Ankara Batıkent'te güzellik ve bakım deneyimini yeniden tanımlıyoruz.
          </p>
          <div className="social-links">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                title={s.label}
                className="social-link"
              >
                {s.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Quick links */}
        <div className="footer-section">
          <h4>Hızlı Linkler</h4>
          <ul className="footer-links">
            {quickLinks.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  target={link.external ? '_blank' : undefined}
                  rel={link.external ? 'noopener noreferrer' : undefined}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-section">
          <h4>İletişim</h4>
          <div className="footer-contact-item">
            <span className="footer-contact-icon">📍</span>
            <p>{branch.address}</p>
          </div>
          <div className="footer-contact-item">
            <span className="footer-contact-icon">📞</span>
            <a href={`tel:${branch.phonePlain}`}>{branch.phone}</a>
          </div>
          <div className="footer-contact-item">
            <span className="footer-contact-icon">🕐</span>
            <p>{hoursSummary}</p>
          </div>
          <div className="footer-contact-item">
            <span className="footer-contact-icon" style={{ color: '#25D366' }}>💬</span>
            <a
              href={`https://wa.me/${branch.phonePlain}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#25D366' }}
            >
              WhatsApp ile Yaz
            </a>
          </div>
        </div>

        {/* Randevu */}
        <div className="footer-section">
          <h4>Randevu Al</h4>
          <p style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.85rem', fontWeight: 300, lineHeight: 1.7, marginBottom: 22 }}>
            Uygun gün ve saatinizi seçin, uzmanlarımız sizi bekliyor.
          </p>
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-appointment"
            style={{ display: 'block', textAlign: 'center' }}
          >
            📅 Randevu Al
          </a>
        </div>

      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <p>© 2026 Bloome Beauty Batıkent. Tüm hakları saklıdır.</p>
        <div className="footer-bottom-links">
          <button>Gizlilik Politikası</button>
          <button>KVKK</button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
